import React from 'react';
import styled from 'styled-components';
import { Formik, Form, Field } from 'formik';
import { localize } from 'react-localize-redux';

import CtaPrimary from 'components/ui/CtaPrimary';
import CtaSecondary from 'components/ui/CtaSecondary';
import SearchBox from 'components/ui/SearchBox';
import { Select } from 'components/ui/Select';
import { colors } from 'helpers/ColorHelper';

const StyledContainer = styled.div``;

const StyledSearchBox = styled(SearchBox)`
  width: 100%;
`;

const StyledSelect = styled(Select)`
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;

const StyledCtaContainer = styled.div`
  display: flex;
`;

const StyledCtaPrimary = styled(CtaPrimary)`
  flex: 1;
  background-color: ${colors.LIGHT_BLUE_GREY};
  color: ${colors.ULTRAMARINE_BLUE};
`;

const StyledCtaSecondary = styled(CtaSecondary)`
  margin-left: 0.5rem;
  color: ${colors.ULTRAMARINE_BLUE};
  border: none;
`;

const initialValues = {
  search: '',
  filter: 'all',
};

export const ConversationFilters = localize()(({ updateFilter, placeholder, translate }) => {
  function handleClear(setValues) {
    setValues(initialValues);
    updateFilter(initialValues);
  }

  const filters = [
    {
      value: 'all',
      label: translate('landlordPortal.messaging.all').props.children,
    },
    {
      value: 'unread',
      label: translate('landlordPortal.messaging.unread').props.children,
    },
    {
      value: 'tenants',
      label: translate('landlordPortal.messaging.tenants').props.children,
    },
    {
      value: 'applicants',
      label: translate('landlordPortal.messaging.applicants').props.children,
    },
  ];

  return (
    <StyledContainer>
      <Formik
        initialValues={initialValues}
        onSubmit={values => {
          updateFilter(values);
        }}
      >
        {({ values, handleChange, handleBlur, setValues }) => {
          const hasBeenTouched =
            values.search !== initialValues.search || values.filter !== initialValues.filter;
          return (
            <Form>
              <Field
                type="text"
                name="search"
                placeholder={placeholder}
                withButton={false}
                component={StyledSearchBox}
                handleChange={handleChange}
                value={values.search}
                accentColor={colors.LIGHT_PERIWINKLE}
              />
              <StyledSelect
                options={filters}
                name="filter"
                value={values.filter}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <StyledCtaContainer>
                <StyledCtaPrimary>{translate('landlordPortal.messaging.apply')}</StyledCtaPrimary>
                {hasBeenTouched && (
                  <StyledCtaSecondary role="button" onClick={() => handleClear(setValues)}>
                    {translate('landlordPortal.messaging.clear')}
                  </StyledCtaSecondary>
                )}
              </StyledCtaContainer>
            </Form>
          );
        }}
      </Formik>
    </StyledContainer>
  );
});
